// Wave-A harness — escrita MECÂNICA do .apolo/progress.md ao fim de run que
// editou arquivos (repo as system of record; doutrina Anthropic/OpenAI). Vive
// FORA de loop/ porque toca a bridge window.apolo (arch: loop/ é framework-free).
// Nunca lança: progresso jamais derruba um run.

import { buildProgressEntry, mergeProgress, PROGRESS_PATH } from './loop/progressFile.js';
import { parseFeatureList, summarizeFeatures, FEATURE_LIST_PATH } from '../../../shared/featureList.mjs';

/** @param {{root?: string, taskText?: string, spine?: any, stopReason?: string}} [run] */
/** Placar da feature list do worktree, ou null (nunca lança). Também alimenta o deliveryScore. */
export async function readFeatureSummary(root) {
  try {
    const w = /** @type {any} */ (typeof window !== 'undefined' ? window : null);
    const api = w?.apolo || null;
    if (!root || !api?.file?.read) return null;
    const fr = await api.file.read({ root, filePath: FEATURE_LIST_PATH });
    if (fr && fr.ok !== false && fr.content) return summarizeFeatures(parseFeatureList(fr.content));
    return null;
  } catch { return null; }
}

/** Lê texto de um arquivo do worktree via bridge; '' quando ausente/erro (nunca lança). */
async function readTextFile(api, root, filePath) {
  try {
    const r = await api.file.read({ root, filePath });
    return r && r.ok !== false && typeof r.content === 'string' ? r.content : '';
  } catch { return ''; }
}

export async function writeProgressFile({ root, taskText, spine, stopReason } = {}) {
  try {
    if (!spine?.wroteFile || !root) return false;
    const w = /** @type {any} */ (typeof window !== 'undefined' ? window : null);
    const api = w?.apolo || null;
    if (!api?.file?.read || !api?.file?.write) return false;
    const files = [...new Set((spine.writtenFiles || []).map((f) => f?.path).filter(Boolean))];
    const features = await readFeatureSummary(root);
    const entry = buildProgressEntry({ now: new Date(), taskText, stopReason, files, features });
    const existing = await readTextFile(api, root, PROGRESS_PATH);
    const res = await api.file.write({ root, filePath: PROGRESS_PATH, content: mergeProgress(existing, entry) });
    return !(res && res.ok === false);
  } catch {
    return false;
  }
}
